/*
 * @Author: cmchiu
 * @Date: 2022-09-02 17:48:15
 * @LastEditTime: 2022-10-03 11:44:50
 * @LastEditors: cmchiu
 * @Description:
 * @FilePath: \LearningMarket\LearningMarket-ClientApp\src\utils\request.js
 *
 */
import axios from 'axios'
import { /* MessageBox, */ Message } from 'element-ui'

// create an axios instance
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
    withCredentials: true, // send cookies when cross-domain requests
    headers: {
        post: { 'Content-Type': 'application/json;charset=UTF-8' },
    },
    timeout: 5000, // request timeout
})

// request interceptor
service.interceptors.request.use(
    config => {
        // do something before request is sent

        /* if (store.getters.token) {
            // let each request carry token
            // ['X-Token'] is a custom headers key
            // please modify it according to the actual situation
            config.headers['Authorization'] = 'Bearer ' + getToken()
        } */
        return config
    },
    error => {
        // do something with request error
        console.log(error) // for debug
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    /**
     * If you want to get http information such as headers or status
     * Please return  response => response
     */

    /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
    response => {
        const res = response.data

        // if the custom code is not 20000, it is judged as an error.
        if (response.status >= 200 && response.status < 300 && !res.Code) {
            if (response.headers['content-length'] === '0') {
                return null
            } else {
                return res
            }
        } else if (res.Code !== 1 && res.Code !== 5000) {
            const contentType = [
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // docx
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // xlsx
                'application/vnd.openxmlformats-officedocument.presentationml.presentation', // pptx
                'application/msword',
                'application/vnd.ms-excel',
                'application/vnd.ms-powerpoint',
                'application/pdf',
                'text/plain',
                'text/xml',
                'application/octet-stream',
                'application/zip',
            ]
            if (
                response.headers['content-type'].indexOf('image') >= 0 ||
                contentType.includes(response.headers['content-type'])
            ) {
                return response
            } else {
                Message({
                    message: res.Msg || 'Error',
                    type: 'error',
                    duration: 5 * 1000,
                })

                /* // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
                if (res.Code === 50008 || res.Code === 50012 || res.Code === 50014) {
                    // to re-login
                    MessageBox.confirm(
                        'You have been logged out, you can cancel to stay on this page, or log in again',
                        'Confirm logout',
                        {
                            confirmButtonText: 'Re-Login',
                            cancelButtonText: 'Cancel',
                            type: 'warning',
                        }
                    ).then(() => {
                        store.dispatch('user/resetToken').then(() => {
                            location.reload()
                        })
                    })
                } */
                return Promise.reject(new Error(res.Msg || 'Error'))
            }
        } else {
            if (res.Code === 5000) {
                Message({
                    message: res.Msg || 'Warning',
                    type: 'warning',
                    duration: 3 * 1000,
                    dangerouslyUseHTMLString: true,
                })
            }

            return res
        }
    },
    error => {
        console.log('err' + error) // for debug
        Message({
            message: error.message || 'Error',
            type: 'error',
            duration: 5 * 1000,
        })
        return Promise.reject(error)
    }
)

export default service
